// CargarResultado.styles.js
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  overflow: hidden;
  height: calc( 100vh - ( var( --navbar-height) + var(--footer-height) ) );
  padding: var(--general-padding);
  transition: padding 0.3s ease;
`;

export const Form = styled.form`
  display: ${({ visible }) => (visible ? "grid" : "none")};
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
  margin: 20px;

`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  
  /* Para que paciente ocupe 2 columnas (si usas grid con 2 o más columnas) */
  &.wide {
    grid-column: span 2;
  }
`;


export const Label = styled.label`
  font-weight: bold;
  margin-bottom: 5px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
  transition: all 0.2s;

  &:focus {
    border-color: #3399ff;
    box-shadow: 0 0 4px rgba(51, 153, 255, 0.4);
  }
`;

export const FullWidth = styled.div`
  grid-column: span 4;
  margin-bottom: 130px
`;

// export const ScrollableTableContainer = styled.div`
//   width: 100%;
//   max-height: 400px;
//   overflow: auto;
//   margin-top: ${({ excelLoaded }) => (excelLoaded ? "0" : "20px")};
// `;

export const Table = styled.table`
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: var(--app-font-size);

  th,
  td {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
    white-space: nowrap;
  }

  th {
    background-color: #e0f0f0;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  td.editable {
    background-color: #fff7e6;
  }

  td.actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  input {
    width: 100px;
    padding: 4px;
    font-size: 12px;
  }
`;

// export const DivContainer = styled.div`
//   border: ${({ excelLoaded }) => (excelLoaded ? "none" : "1px solid #ccc")};
//   border-radius: ${({ excelLoaded }) => (excelLoaded ? "0" : "4px")};
//   overflow: hidden;
//   max-width: ${({ excelLoaded }) => (excelLoaded ? "100%" : "90%")};
// `;


export const Header = styled.div`
  background-color: ${({ theme }) => theme.HeadersBackground};
  min-height: 40px;
  color: ${({ theme }) => theme.TextWhite};
  display: flex;
  align-items: center;
  padding: 0px 16px;
  font-size: var(--app-font-size, 16px);
  font-weight: bold;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

export const HiddenInput = styled.input`
  display: none;
`;


export const Select = styled.select`
  width: 100%;
  max-width: 250px;
  padding: 6px 8px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 0.95rem;
  background: #fff;
`;
	
export const CustomSelect = styled.div`
  width: 100%;
  font-size: var(--app-font-size);
  .react-select__control {
    min-height: 36px;
    height: 36px;
    border-radius: 8px;
    font-size: var(--app-font-size);
  }
  .react-select__value-container {
    padding: 0 6px;
    height: 36px;
  }
  .react-select__menu {
    font-size: var(--app-font-size);
  }
`;




export const DivContainer = styled.div`
  flex: 1; /* ocupa el espacio sobrante */
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border: ${({ excelLoaded }) => (excelLoaded ? "none" : "1px solid #ccc")};
  border-radius: ${({ excelLoaded }) => (excelLoaded ? "0" : "4px")};
`;

export const ScrollableTableContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  margin-top: ${({ excelLoaded }) => (excelLoaded ? "0" : "20px")};
`;
